<template>
  <i>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
      <path :d="mdiChevronDown" />
    </svg>
  </i>
</template>

<script setup>
import { mdiChevronDown } from "@mdi/js";
</script>